// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"styles_notFoundContainer__6367B"};